import React, { type PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@mui/material'

type ReverseButtonWrapperProps = PropsWithChildren & {
  hasPendingRefundInvoice: boolean
  shouldPreventReverse?: boolean
}

export const ReverseButtonWrapper = ({
  children,
  hasPendingRefundInvoice,
  shouldPreventReverse,
}: ReverseButtonWrapperProps) => {
  const { t } = useTranslation(['Common', 'Invoices', 'Payments'])

  if (hasPendingRefundInvoice) {
    return (
      <Tooltip placement="top" title={t('Payments:REFUND_INVOICE_PENDING')}>
        <span>{children}</span>
      </Tooltip>
    )
  }
  if (shouldPreventReverse) {
    return (
      <Tooltip placement="top" title={t('Payments:USE_REFUND_INSTEAD')}>
        <span>{children}</span>
      </Tooltip>
    )
  }
  return <>{children}</>
}
